import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import LandingLayout from '../components/Layouts/LandingLayout';
import DashboardLayout from '../components/Layouts/DashboardLayout';

import DashboardPage from '../pages/Private/Dashboard';

import LandingPage from '../pages/Public/Landing';
import LoginPage from '../pages/Public/Login';
import MFAPage from '../pages/Public/Mfa';

const routes = [
	{
		path: '/',
		element: <LandingLayout />,
		children: [
			{
				index: true,
				element: <LandingPage />
			},
			{
				path: 'login',
				element: <LoginPage />
			},
			{
				path: 'mfa',
				element: <MFAPage />
			}
		]
	},
	{
		path: '/dashboard',
		element: <DashboardLayout />,
		children: [
			{
				index: true,
				element: <DashboardPage />
			}
		]
	}
];

export default createBrowserRouter(routes);
